import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Lock, Sparkles } from 'lucide-react';
import { TaraCard, TaraCardHeader, TaraCardTitle, TaraCardContent } from '../components/ui/TaraCard';
import TaraButton from '../components/ui/TaraButton';
import { toast } from 'sonner';

const PaymentNew = () => {
  const navigate = useNavigate();
  
  const handleUnlock = () => {
    localStorage.setItem('story_unlocked', 'true');
    toast.success('✨ Full access unlocked!');
    navigate('/home');
  };
  
  return (
    <div className="min-h-screen bg-cosmic-dusk px-5 py-8">
      <div className="max-w-md mx-auto space-y-8">
        {/* Header */}
        <div className="text-center space-y-2">
          <h1 className="font-serif text-3xl md:text-4xl font-medium text-stone-900">
            Your future journey is ready
          </h1>
          <p className="text-base text-stone-600">
            Unlock your full dashboard + future story
          </p>
        </div>
        
        {/* Preview Cards (Blurred) */}
        <div className="space-y-4">
          <TaraCard className="relative overflow-hidden">
            <div className="blur-sm">
              <TaraCardHeader>
                <TaraCardTitle>Health Timeline</TaraCardTitle>
              </TaraCardHeader>
              <TaraCardContent>
                <div className="h-32 bg-gradient-to-r from-cosmic-100 to-sacred-100 rounded-lg" />
              </TaraCardContent>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <Lock className="w-10 h-10 text-stone-400" />
            </div>
          </TaraCard>
          
          <TaraCard className="relative overflow-hidden">
            <div className="blur-sm">
              <TaraCardHeader>
                <TaraCardTitle>Disease Risk Radar</TaraCardTitle>
              </TaraCardHeader>
              <TaraCardContent>
                <div className="h-32 bg-gradient-to-r from-green-100 to-amber-100 rounded-lg" />
              </TaraCardContent>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <Lock className="w-10 h-10 text-stone-400" />
            </div>
          </TaraCard>
        </div>
        
        {/* What's Included */}
        <TaraCard variant="cosmic">
          <TaraCardHeader>
            <TaraCardTitle>What's included</TaraCardTitle>
          </TaraCardHeader>
          <TaraCardContent>
            <div className="space-y-3">
              {[
                'Full health dashboard with vitality score',
                'Future predictions for next 10+ years',
                'Audio guidance from Sage Varta',
                'Interactive timeline calendar',
                'Personalized remedies & habits',
              ].map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-cosmic-500 mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-stone-700">{item}</span>
                </div>
              ))}
            </div>
          </TaraCardContent>
        </TaraCard>
        
        {/* CTA Button */}
        <TaraButton
          variant="sacred"
          size="lg"
          className="w-full"
          onClick={handleUnlock}
          icon={<Sparkles className="w-5 h-5" />}
        >
          Unlock My Path – ₹999
        </TaraButton>
        
        {/* Trust Note */}
        <p className="text-xs text-center text-stone-500">
          One-time payment · No hidden charges · 7-day money-back guarantee
        </p>
      </div>
    </div>
  );
};

export default PaymentNew;